module.exports = __webpack_public_path__ + "img/home-image.f27853d0.png";